module.exports = __webpack_public_path__ + "img/sld_scb_3_t1_green.f2d88f5c.svg";